import {WidgetDescription, WidgetSettingsSchemaField} from '../../components/layout/widget/widget-description';
import {EmptyWidgetImplementation} from './empty-widget-implementation.service';
import {EMPTY_WIDGET_TYPE_ID} from './empty-widget-type-id';
import {EmptyWidgetComponent} from './empty-widget.component';
import {EmptyWidgetSettings, EmptyWidgetSettingsService} from './settings';

interface EmptyWidgetSettingsSchemaField extends WidgetSettingsSchemaField {
    readonly name: keyof EmptyWidgetSettings;
}

export interface EmptyWidgetDescription extends WidgetDescription {
    settingsSchema: EmptyWidgetSettingsSchemaField[];
}

export const EMPTY_WIDGET_DESCRIPTION: EmptyWidgetDescription = {
    widgetTypeId:                EMPTY_WIDGET_TYPE_ID,
    widgetLabel:                 'components.widgets.empty-widget.widget_name',
    widgetImplementationType:    EmptyWidgetImplementation,
    widgetComponentType:         EmptyWidgetComponent,
    widgetSettingsServiceType:   EmptyWidgetSettingsService,
    settingsSchema:              [
        {
            name: 'title',
            isShareable: false
        }
    ],
    hasGroupingSupport:          false,
    widgetSettingsComponentType: null
};
